import { makeAutoObservable } from 'mobx'
import { type IResponseMediaShort } from 'entities/Attachment'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SMSMessageFieldStore } from 'widgets/MessageFormFields/SMSMessageField/store/SMSMessageFieldStore'

export class CampaignSMSStore {
  private _smsMessageFieldStore: SMSMessageFieldStore

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._smsMessageFieldStore = new SMSMessageFieldStore(
      {
        onFocus: () => {
          this.setError('')
        },
        messageFieldStoreProps: {
          resetOnUnmount: false,
        },
        isMarketing: true,
      },
      this._entities
    )
  }

  init = (message: string, media_url: IResponseMediaShort[]) => {
    this._smsMessageFieldStore.init(message, media_url)
  }

  get smsMessageFieldStore() {
    return this._smsMessageFieldStore
  }

  get messageDataParams() {
    return this._smsMessageFieldStore.messageDataParams
  }

  get messageFieldStore() {
    return this._smsMessageFieldStore.messageFieldStore
  }

  get isError() {
    return !!this.error || this._smsMessageFieldStore.isError
  }

  error = ''
  setError = (value: typeof this.error) => {
    this.error = value
  }

  checkValidate = () => {
    let validate = true
    if (!this.messageDataParams.message.trim().length && !this.messageDataParams.media_url.length) {
      validate = false
      this.setError('Your message is the key – please write it above')
    }
    return validate
  }
}
